"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.CurrentMessageLocale = exports.LocaleData = exports.getCurrentMessageLocale = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        //@ts-ignore
        globalContainer = self;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
var getCurrentMessageLocale = function () {
    var localize = getLocalize();
    if (localize.message.currentLocale === undefined) {
        throw Error('The localize.message.currentLocale has not been set');
    }
    return localize.message.currentLocale;
};
exports.getCurrentMessageLocale = getCurrentMessageLocale;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return (0, exports.getLocalizeFormat)().localeData; } };
/* istanbul ignore next */
exports.CurrentMessageLocale = { get: function () { return (0, exports.getCurrentMessageLocale)(); } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    ExpandLabel: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/ExpandLabel'); },
    ExpandOnlineMessage: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/ExpandOnlineMessage'); },
    ExpandServerMessage: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/ExpandServerMessage'); },
    HelpText: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/HelpText'); },
    LargeDatasourceWarning: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/LargeDatasourceWarning'); },
    DismissLargeDatasourceButtonLabel: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/DismissLargeDatasourceButtonLabel'); },
    PublishDatasourcesButtonLabel: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/PublishDatasourcesButtonLabel'); },
    RetryButtonLabel: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/RetryButtonLabel'); },
    DialogTitle: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/DialogTitle'); },
    DatasourceWarningTitle: function () { return t('@tableau__open-workbook-in-desktop-dialog-content/DatasourceWarningTitle'); },
};
//# sourceMappingURL=Localize.js.map